import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import bn from "./translations/bn.json";
import en from "./translations/en.json";
import gu from "./translations/gu.json";
import hi from "./translations/hi.json";
import kn from "./translations/kn.json";
import ml from "./translations/ml.json";
import mr from "./translations/mr.json";
import pa from "./translations/pa.json";
import ta from "./translations/ta.json";
import te from "./translations/te.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      hi: { translation: hi },
      mr: { translation: mr },
      gu: { translation: gu },
      bn: { translation: bn },
      ta: { translation: ta },
      te: { translation: te },
      kn: { translation: kn },
      ml: { translation: ml },
      pa: { translation: pa },
    },
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;